export function AdvanceActionDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.type = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AdvanceActionDescriptor.type' } });
									/*
                    * C# parametr type: Boolean
                    */
                    me.anyTargetValue = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AdvanceActionDescriptor.anyTargetValue' } });
									/*
                    * C# parametr type: String
                    */
                    me.targetValue = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AdvanceActionDescriptor.targetValue' } });
									/*
                    * C# parametr type: String
                    */
                    me.confirmKey = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AdvanceActionDescriptor.confirmKey' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.caseSensitive = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AdvanceActionDescriptor.caseSensitive' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.disableNextTilInput = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AdvanceActionDescriptor.disableNextTilInput' } });
									/*
                    * C# parametr type: String
                    */
                    me.regex = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AdvanceActionDescriptor.regex' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function AnimationDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.type = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnimationDescriptor.type' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: List`1 (class/struct)
                    */
                    me.funcChain = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnimationDescriptor.funcChain' } });
                    
										mappingOptions.funcChain = { create: function(options) { return new Object(options.data, me, parents); } };
                    				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function AnimationItemDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: ElementDescriptor
                    */
                    me.element = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnimationItemDescriptor.element' } });
									/*
                    * C# parametr type: AnimationDescriptor
                    */
                    me.animationDescriptor = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnimationItemDescriptor.animationDescriptor' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function AnnouncementsChannelDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Dictionary`2
                    */
                    me.historyTitleText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnnouncementsChannelDescriptor.historyTitleText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.showHistoryButtonText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnnouncementsChannelDescriptor.showHistoryButtonText' } });
									/*
                    * C# parametr type: TriggerDescriptor
                    */
                    me.trigger = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnnouncementsChannelDescriptor.trigger' } });
									/*
                    * C# parametr type: UrlFilterDescriptor
                    */
                    me.urlFilter = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnnouncementsChannelDescriptor.urlFilter' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.segment = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnnouncementsChannelDescriptor.segment' } });
									/*
                    * C# parametr type: RulesDescriptor
                    */
                    me.rules = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnnouncementsChannelDescriptor.rules' } });
									/*
                    * C# parametr type: DateTime
                    */
                    me.lastSeenAt = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnnouncementsChannelDescriptor.lastSeenAt' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function AnnouncementsCollectionDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: AnnouncementsChannelDescriptor (class/struct)
                    */
                    me.channels = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnnouncementsCollectionDescriptor.channels' } });
                    
										mappingOptions.channels = { create: function(options) { return new AnnouncementsChannelDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ChangelogDescriptor (class/struct)
                    */
                    me.changelogs = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'AnnouncementsCollectionDescriptor.changelogs' } });
                    
										mappingOptions.changelogs = { create: function(options) { return new ChangelogDescriptor(options.data, me, parents); } };
                    				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function BackdropDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.visible = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'BackdropDescriptor.visible' } });
									/*
                    * C# parametr type: String
                    */
                    me.type = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'BackdropDescriptor.type' } });
									/*
                    * C# parametr type: String
                    */
                    me.backgroundColor = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'BackdropDescriptor.backgroundColor' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ButtonBadgeDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.type = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonBadgeDescriptor.type' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.message = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonBadgeDescriptor.message' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.tourIdClosed = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonBadgeDescriptor.tourIdClosed' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ButtonContentDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Boolean
                    */
                    me.hasSearch = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonContentDescriptor.hasSearch' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ButtonItemDescriptor (class/struct)
                    */
                    me.items = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonContentDescriptor.items' } });
                    
										mappingOptions.items = { create: function(options) { return new ButtonItemDescriptor(options.data, me, parents); } };
                    				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ButtonDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.v = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.v' } });
									/*
                    * C# parametr type: Boolean
                    */
                    me.isActive = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.isActive' } });
									/*
                    * C# parametr type: ButtonBadgeDescriptor
                    */
                    me.badge = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.badge' } });
									/*
                    * C# parametr type: ButtonContentDescriptor
                    */
                    me.content = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.content' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ButtonItemDescriptor (class/struct)
                    */
                    me.launchers = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.launchers' } });
                    
										mappingOptions.launchers = { create: function(options) { return new ButtonItemDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: Nullable`1
                    */
                    me.movable = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.movable' } });
									/*
                    * C# parametr type: String
                    */
                    me.toolBtnsStyle = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.toolBtnsStyle' } });
									/*
                    * C# parametr type: Boolean
                    */
                    me.showChangelogs = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.showChangelogs' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.announcementsChannel = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.announcementsChannel' } });
									/*
                    * C# parametr type: Boolean
                    */
                    me.showFeedback = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.showFeedback' } });
									/*
                    * C# parametr type: String
                    */
                    me.chat = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.chat' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ButtonCustomButtonDescriptor (class/struct)
                    */
                    me.customButtons = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.customButtons' } });
                    
										mappingOptions.customButtons = { create: function(options) { return new ButtonCustomButtonDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: ButtonToursBlockDescriptor
                    */
                    me.toursBlock = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.toursBlock' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ButtonWidgetDescriptor (class/struct)
                    */
                    me.widgets = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.widgets' } });
                    
										mappingOptions.widgets = { create: function(options) { return new ButtonWidgetDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: UrlFilterDescriptor
                    */
                    me.urlFilter = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.urlFilter' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.titleText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.titleText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.widgetsTitleText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.widgetsTitleText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.toursTitleText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.toursTitleText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.sendFeedbackButtonText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.sendFeedbackButtonText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.showChangelogsButtonText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.showChangelogsButtonText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
					me.chatBtnText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.chatBtnText' } });
					me.chatMsgNotifText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.chatMsgNotifText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.buttonText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.buttonText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.searchFieldText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.searchFieldText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.searchNoResultsText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.searchNoResultsText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.searchResultsTitleText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.searchResultsTitleText' } });
									/*
                    * C# parametr type: ButtonDesign
                    */
                    me.design = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonDescriptor.design' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ButtonCustomButtonDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.url = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonCustomButtonDescriptor.url' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.text = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonCustomButtonDescriptor.text' } });
									/*
                    * C# parametr type: String
                    */
                    me.cssClass = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonCustomButtonDescriptor.cssClass' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.blank = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonCustomButtonDescriptor.blank' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ButtonInputDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.visible = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonInputDescriptor.visible' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.text = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonInputDescriptor.text' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ButtonItemDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

					me.id = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.id' } });

								/*
                    * C# parametr type: String
                    */
                    me.type = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.type' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.name = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.name' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.desc = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.desc' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.keyw = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.keyw' } });
									/*
                    * C# parametr type: String
                    */
                    me.ico = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.ico' } });
									/*
                    * C# parametr type: String
                    */
                    me.opts = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.opts' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ButtonItemDescriptor (class/struct)
                    */
                    me.subs = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.subs' } });
                    
										mappingOptions.subs = { create: function(options) { return new ButtonItemDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: Nullable`1
                    */
                    me.segmentId = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.segmentId' } });
									/*
                    * C# parametr type: RulesDescriptor
                    */
                    me.rules = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.rules' } });
									/*
                    * C# parametr type: UrlFilterDescriptor
                    */
                    me.urlFilter = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.urlFilter' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.doneOnFinished = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonItemDescriptor.doneOnFinished' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ButtonTourDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Int64
                    */
                    me.tourId = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonTourDescriptor.tourId' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.title = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonTourDescriptor.title' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.category = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonTourDescriptor.category' } });
									/*
                    * C# parametr type: String
                    */
                    me.navigateTo = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonTourDescriptor.navigateTo' } });
									/*
                    * C# parametr type: UrlFilterDescriptor
                    */
                    me.urlFilter = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonTourDescriptor.urlFilter' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.showAsFinishedInButton = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonTourDescriptor.showAsFinishedInButton' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ButtonToursBlockDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ButtonTourDescriptor (class/struct)
                    */
                    me.shownTours = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonToursBlockDescriptor.shownTours' } });
                    
										mappingOptions.shownTours = { create: function(options) { return new ButtonTourDescriptor(options.data, me, parents); } };
                    				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ButtonWidgetDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.type = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonWidgetDescriptor.type' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.title = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonWidgetDescriptor.title' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.url = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonWidgetDescriptor.url' } });
									/*
                    * C# parametr type: UrlFilterDescriptor
                    */
                    me.urlFilter = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonWidgetDescriptor.urlFilter' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function CardContentDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: TourCardTitleDescriptor
                    */
                    me.title = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardContentDescriptor.title' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.body = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardContentDescriptor.body' } });
									/*
                    * C# parametr type: TourCardFooterDescriptor
                    */
                    me.footer = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardContentDescriptor.footer' } });
									/*
                    * C# parametr type: String
                    */
                    me.skipButtonType = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardContentDescriptor.skipButtonType' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function CardDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.id = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.id' } });
									/*
                    * C# parametr type: String
                    */
                    me.name = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.name' } });
									/*
                    * C# parametr type: StringValue
                    */
                    me.url = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.url' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ElementDescriptor (class/struct)
                    */
                    me.elements = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.elements' } });
                    
										mappingOptions.elements = { create: function(options) { return new ElementDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: Nullable`1
                    */
                    me.continueOnElementClick = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.continueOnElementClick' } });
									/*
                    * C# parametr type: AdvanceActionDescriptor
                    */
                    me.advanceAction = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.advanceAction' } });
									/*
                    * C# parametr type: AnimationDescriptor
                    */
                    me.elementAnimation = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.elementAnimation' } });
									/*
                    * C# parametr type: BackdropDescriptor
                    */
                    me.backdrop = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.backdrop' } });
									/*
                    * C# parametr type: CardContentDescriptor
                    */
                    me.content = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.content' } });
									/*
                    * C# parametr type: String
                    */
                    me.displayType = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.displayType' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.showDelayMs = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.showDelayMs' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.pauseTillReload = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.pauseTillReload' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.advanceOnRemove = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.advanceOnRemove' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: String (class/struct)
                    */
                    me.blockedKeys = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.blockedKeys' } });
                    
														/*
                    * C# parametr type: Nullable`1
                    */
                    me.advanceIfElMissing = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.advanceIfElMissing' } });
									/*
                    * C# parametr type: Nullable`1
                    */
					me.advanceIfElMissingDelay = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.advanceIfElMissingDelay' } });

					me.reloadOnHide = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.reloadOnHide' } });
									/*
                    * C# parametr type: PositionValue
                    */
                    me.cardPosition = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'CardDescriptor.cardPosition' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ChangelogCollectionDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.isActive = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogCollectionDescriptor.isActive' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.showInButton = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogCollectionDescriptor.showInButton' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.historyTitleText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogCollectionDescriptor.historyTitleText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.showHistoryButtonText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogCollectionDescriptor.showHistoryButtonText' } });
									/*
                    * C# parametr type: TriggerDescriptor
                    */
                    me.trigger = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogCollectionDescriptor.trigger' } });
									/*
                    * C# parametr type: UrlFilterDescriptor
                    */
                    me.urlFilter = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogCollectionDescriptor.urlFilter' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ChangelogDescriptor (class/struct)
                    */
                    me.changelogs = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogCollectionDescriptor.changelogs' } });
                    
										mappingOptions.changelogs = { create: function(options) { return new ChangelogDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: Boolean
                    */
                    me.userHasUnread = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogCollectionDescriptor.userHasUnread' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ChangelogDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.id = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogDescriptor.id' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.title = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogDescriptor.title' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.content = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogDescriptor.content' } });
									/*
                    * C# parametr type: DateTime
                    */
                    me.publishedAt = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogDescriptor.publishedAt' } });
									/*
                    * C# parametr type: ThemeDescriptor
                    */
                    me.themeConfig = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogDescriptor.themeConfig' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.closeable = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogDescriptor.closeable' } });
									/*
                    * C# parametr type: String[]
                    *  - Generic parametr of type:  
                    */
                    me.availableLngs = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogDescriptor.availableLngs' } });
                    
														/*
                    * C# parametr type: ActionButton
                    */
                    me.primaryBtn = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogDescriptor.primaryBtn' } });
									/*
                    * C# parametr type: String
                    */
                    me.btnsPos = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogDescriptor.btnsPos' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ChecklistDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Int64
                    */
                    me.id = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.id' } });
									/*
                    * C# parametr type: String
                    */
                    me.name = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.name' } });
									/*
                    * C# parametr type: String
                    */
                    me.type = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.type' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.state = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.state' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ChecklistDescriptorItem (class/struct)
                    */
                    me.items = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.items' } });
                    
										mappingOptions.items = { create: function(options) { return new ChecklistDescriptorItem(options.data, me, parents); } };
                    									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.title = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.title' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.description = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.description' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.doneTitle = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.doneTitle' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.doneDescription = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.doneDescription' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.doneCloseText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.doneCloseText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.dismissText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.dismissText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.dismissConfirmText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.dismissConfirmText' } });
									/*
                    * C# parametr type: String
                    */
                    me.startMode = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.startMode' } });
									/*
                    * C# parametr type: String
                    */
                    me.displayMode = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.displayMode' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.segmentId = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.segmentId' } });
									/*
                    * C# parametr type: RulesDescriptor
                    */
                    me.rules = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.rules' } });
									/*
                    * C# parametr type: UrlFilterDescriptor
                    */
                    me.urlFilter = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptor.urlFilter' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ChecklistDescriptorItem(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.id = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.id' } });
									/*
                    * C# parametr type: String
                    */
                    me.type = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.type' } });
									/*
                    * C# parametr type: String
                    */
                    me.completeType = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.completeType' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.checkedSegmentId = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.checkedSegmentId' } });
									/*
                    * C# parametr type: RulesDescriptor
                    */
                    me.checkedRules = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.checkedRules' } });
									/*
                    * C# parametr type: String
                    */
                    me.state = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.state' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.title = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.title' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.description = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.description' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.doneBtnText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.doneBtnText' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.tourId = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.tourId' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.mobTourId = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.mobTourId' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.url = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.url' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.urlBlank = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.urlBlank' } });
									/*
                    * C# parametr type: String
                    */
                    me.customId = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistDescriptorItem.customId' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ChecklistsCollectionDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ChecklistDescriptor (class/struct)
                    */
                    me.checklists = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistsCollectionDescriptor.checklists' } });
                    
										mappingOptions.checklists = { create: function(options) { return new ChecklistDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: ChecklistDesign
                    */
                    me.design = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChecklistsCollectionDescriptor.design' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ConfirmationMessageDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Boolean
                    */
                    me.enabled = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ConfirmationMessageDescriptor.enabled' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.text = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ConfirmationMessageDescriptor.text' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.ok = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ConfirmationMessageDescriptor.ok' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.cancel = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ConfirmationMessageDescriptor.cancel' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ContextHelpContentDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: ContextHelpCardTitleDescriptor
                    */
                    me.title = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpContentDescriptor.title' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.body = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpContentDescriptor.body' } });
									/*
                    * C# parametr type: ContextHelpCardFooterDescriptor
                    */
                    me.footer = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpContentDescriptor.footer' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ContextHelpDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.id = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.id' } });
									/*
                    * C# parametr type: String
                    */
                    me.name = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.name' } });
									/*
                    * C# parametr type: ElementDescriptor
                    */
                    me.element = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.element' } });
									/*
                    * C# parametr type: TriggerDescriptor
                    */
			me.trigger = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.trigger' } });
			/*
	* C# parametr type: TriggerDescriptor
	*/
			me.cardTrigger = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.cardTrigger' } });
									/*
                    * C# parametr type: StringValue
                    */
                    me.targetUrl = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.targetUrl' } });
									/*
                    * C# parametr type: BackdropDescriptor
                    */
                    me.backdrop = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.backdrop' } });
									/*
                    * C# parametr type: String
                    */
                    me.iconType = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.iconType' } });
									/*
                    * C# parametr type: PositionValue
                    */
                    me.iconPosition = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.iconPosition' } });
									/*
                    * C# parametr type: PositionValue
                    */
                    me.cardPosition = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.cardPosition' } });
									/*
                    * C# parametr type: IconSizingValue
                    */
                    me.iconSizing = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.iconSizing' } });
									/*
                    * C# parametr type: ContextHelpContentDescriptor
                    */
                    me.content = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.content' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.showDelayMs = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.showDelayMs' } });
									/*
                    * C# parametr type: ContextHelpViewStates
                    */
                    me.userState = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.userState' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.containerId = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpDescriptor.containerId' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ContextHelpsCollectionDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ContextHelpsGroupDescriptor (class/struct)
                    */
                    me.containers = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpsCollectionDescriptor.containers' } });
                    
										mappingOptions.containers = { create: function(options) { return new ContextHelpsGroupDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: ContextHelpDesign
                    */
                    me.design = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpsCollectionDescriptor.design' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ContextHelpsGroupDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.active = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpsGroupDescriptor.active' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: ContextHelpDescriptor (class/struct)
                    */
                    me.helps = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpsGroupDescriptor.helps' } });
                    
										mappingOptions.helps = { create: function(options) { return new ContextHelpDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: Nullable`1
                    */
                    me.segment = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpsGroupDescriptor.segment' } });
									/*
                    * C# parametr type: RulesDescriptor
                    */
                    me.rules = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpsGroupDescriptor.rules' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ElementDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.id = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ElementDescriptor.id' } });
									/*
                    * C# parametr type: String
                    */
                    me.query = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ElementDescriptor.query' } });
									/*
                    * C# parametr type: String
                    */
                    me.iframe = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ElementDescriptor.iframe' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function FeedbackDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Boolean
                    */
                    me.isActive = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.isActive' } });
									/*
                    * C# parametr type: Boolean
                    */
                    me.allowScreenshots = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.allowScreenshots' } });
									/*
                    * C# parametr type: Boolean
                    */
                    me.allowVideos = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.allowVideos' } });
									/*
                    * C# parametr type: Boolean
                    */
                    me.allowVoting = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.allowVoting' } });
									/*
                    * C# parametr type: Boolean
                    */
			me.allowText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.allowText' } });

			me.recMode = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.recMode' } });
									/*
                    * C# parametr type: Boolean
                    */
                    me.showInButton = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.showInButton' } });
									/*
                    * C# parametr type: UrlFilterDescriptor
                    */
                    me.urlFilter = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.urlFilter' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.mainButtonText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.mainButtonText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.textPlaceholderText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.textPlaceholderText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.attachScreenshotButtonText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.attachScreenshotButtonText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.sendButtonText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.sendButtonText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.popupTitleText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.popupTitleText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.sendingInProgressText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.sendingInProgressText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.successSendingText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.successSendingText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.failedSendingText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.failedSendingText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.closeText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.closeText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.buttonHighlightText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.buttonHighlightText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.buttonBlackenText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.buttonBlackenText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.buttonAttachText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.buttonAttachText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.videoStartHindText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.videoStartHindText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.recordVideoText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.recordVideoText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.gettingScreenshotText = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.gettingScreenshotText' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.warningScreenshots = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.warningScreenshots' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.warningRecordings = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.warningRecordings' } });
									/*
                    * C# parametr type: FeedbackDesign
                    */
                    me.design = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'FeedbackDescriptor.design' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function RuleDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: RuleExpression
                    */
                    me.expression = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleDescriptor.expression' } });
									/*
                    * C# parametr type: RefinedRule
                    */
                    me.refinedRule = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleDescriptor.refinedRule' } });
									/*
                    * C# parametr type: RulesDescriptor
                    */
                    me.subRules = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleDescriptor.subRules' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function RuleDescriptorEvaluated(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.evaluatedResult = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleDescriptorEvaluated.evaluatedResult' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.evaluatedCount = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleDescriptorEvaluated.evaluatedCount' } });
									/*
                    * C# parametr type: RuleExpression
                    */
                    me.expression = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleDescriptorEvaluated.expression' } });
									/*
                    * C# parametr type: RefinedRule
                    */
                    me.refinedRule = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleDescriptorEvaluated.refinedRule' } });
									/*
                    * C# parametr type: RulesDescriptor
                    */
                    me.subRules = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleDescriptorEvaluated.subRules' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function RuleExpression(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.prop = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleExpression.prop' } });
									/*
                    * C# parametr type: String
                    */
                    me.op = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleExpression.op' } });
									/*
                    * C# parametr type: String
                    */
                    me.val = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleExpression.val' } });
									/*
                    * C# parametr type: String
                    */
                    me.valFrom = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleExpression.valFrom' } });
									/*
                    * C# parametr type: String
                    */
                    me.valTo = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleExpression.valTo' } });
									/*
                    * C# parametr type: String
                    */
                    me.data = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RuleExpression.data' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function RefinedRule(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.atLeastTimes = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RefinedRule.atLeastTimes' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.periodAmount = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RefinedRule.periodAmount' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.periodUnit = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RefinedRule.periodUnit' } });
									/*
                    * C# parametr type: String
                    */
                    me.attrCondOp = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RefinedRule.attrCondOp' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: RuleExpression (class/struct)
                    */
                    me.attrExpressions = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RefinedRule.attrExpressions' } });
                    
										mappingOptions.attrExpressions = { create: function(options) { return new RuleExpression(options.data, me, parents); } };
                    				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function RulesDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.condOp = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RulesDescriptor.condOp' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: RuleDescriptor (class/struct)
                    */
                    me.rules = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RulesDescriptor.rules' } });
                    
										mappingOptions.rules = { create: function(options) { return new RuleDescriptor(options.data, me, parents); } };
                    				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function RulesDescriptorEvaluated(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.condOp = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RulesDescriptorEvaluated.condOp' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: RuleDescriptorEvaluated (class/struct)
                    */
                    me.rules = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'RulesDescriptorEvaluated.rules' } });
                    
										mappingOptions.rules = { create: function(options) { return new RuleDescriptorEvaluated(options.data, me, parents); } };
                    				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function SegmentDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Int64
                    */
                    me.id = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SegmentDescriptor.id' } });
									/*
                    * C# parametr type: RulesDescriptor
                    */
                    me.rules = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SegmentDescriptor.rules' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function SiteConfig(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.version = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.version' } });
									/*
                    * C# parametr type: String
                    */
                    me.cssVersion = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.cssVersion' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: String (class/struct)
                    */
                    me.flags = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.flags' } });
                    
														/*
                    * C# parametr type: Nullable`1
                    */
                    me.dbg = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.dbg' } });
									/*
                    * C# parametr type: AnnouncementsCollectionDescriptor
                    */
                    me.announcements = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.announcements' } });
									/*
                    * C# parametr type: ToursCollectionDescritptor
                    */
                    me.tours = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.tours' } });
									/*
                    * C# parametr type: ChangelogCollectionDescriptor
                    */
                    me.changelogs = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.changelogs' } });
									/*
                    * C# parametr type: ContextHelpsCollectionDescriptor
                    */
                    me.contextHelps = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.contextHelps' } });
									/*
                    * C# parametr type: FeedbackDescriptor
                    */
                    me.feedback = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.feedback' } });
									/*
                    * C# parametr type: ButtonDescriptor
                    */
                    me.button = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.button' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: SegmentDescriptor (class/struct)
                    */
                    me.segments = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.segments' } });
                    
										mappingOptions.segments = { create: function(options) { return new SegmentDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: ChecklistsCollectionDescriptor
                    */
                    me.checklists = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.checklists' } });
									/*
                    * C# parametr type: VisualEventsCollectionDescriptor
                    */
                    me.visualEvents = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.visualEvents' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: IntegrationTypeValue (class/struct)
                    */
                    me.integrations = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SiteConfig.integrations' } });
                    
										mappingOptions.integrations = { create: function(options) { return new IntegrationTypeValue(options.data, me, parents); } };
                    				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ThemeDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.id = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ThemeDescriptor.id' } });
									/*
                    * C# parametr type: String
                    */
                    me.options = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ThemeDescriptor.options' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function TourDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Int64
                    */
                    me.id = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.id' } });
									/*
                    * C# parametr type: String
                    */
                    me.name = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.name' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.isActive = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.isActive' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: TriggerDescriptor (class/struct)
                    */
                    me.triggers = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.triggers' } });
                    
										mappingOptions.triggers = { create: function(options) { return new TriggerDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: Nullable`1
                    */
                    me.segment = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.segment' } });
									/*
                    * C# parametr type: RulesDescriptor
                    */
                    me.rules = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.rules' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: CardDescriptor (class/struct)
                    */
                    me.cards = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.cards' } });
                    
										mappingOptions.cards = { create: function(options) { return new CardDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: Guid (class/struct)
                    */
                    me.userShownCards = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.userShownCards' } });
                    
										mappingOptions.userShownCards = { create: function(options) { return new Object(options.data, me, parents); } };
                    									/*
                    * C# parametr type: Byte
                    */
                    me.userState = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.userState' } });
									/*
                    * C# parametr type: Boolean
                    */
                    me.userIsRunning = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.userIsRunning' } });
									/*
                    * C# parametr type: ConfirmationMessageDescriptor
                    */
                    me.confirmation = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.confirmation' } });
									/*
                    * C# parametr type: TourMinimizationDescriptor
                    */
                    me.minimization = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.minimization' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.showInButton = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.showInButton' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.showAsFinishedInButton = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourDescriptor.showAsFinishedInButton' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function TourMinimizationDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Boolean
                    */
                    me.enabled = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourMinimizationDescriptor.enabled' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.text = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourMinimizationDescriptor.text' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ToursCollectionDescritptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: TourDescriptor (class/struct)
                    */
                    me.tours = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ToursCollectionDescritptor.tours' } });
                    
										mappingOptions.tours = { create: function(options) { return new TourDescriptor(options.data, me, parents); } };
                    									/*
                    * C# parametr type: TourDesign
                    */
                    me.design = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ToursCollectionDescritptor.design' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function TriggerDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.type = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TriggerDescriptor.type' } });
									/*
                    * C# parametr type: ElementDescriptor
                    */
                    me.element = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TriggerDescriptor.element' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.preventDefault = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TriggerDescriptor.preventDefault' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.stopPropagation = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TriggerDescriptor.stopPropagation' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.oneTime = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TriggerDescriptor.oneTime' } });
									/*
                    * C# parametr type: Object
                    */
                    me.options = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TriggerDescriptor.options' } });
									/*
                    * C# parametr type: String
                    */
                    me.code = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TriggerDescriptor.code' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function UrlFilterDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.type = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'UrlFilterDescriptor.type' } });
									/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: StringValue (class/struct)
                    */
                    me.urls = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'UrlFilterDescriptor.urls' } });
                    
										mappingOptions.urls = { create: function(options) { return new StringValue(options.data, me, parents); } };
                    				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function VisualEventDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.id = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VisualEventDescriptor.id' } });
									/*
                    * C# parametr type: String
                    */
                    me.name = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VisualEventDescriptor.name' } });
									/*
                    * C# parametr type: ElementDescriptor
                    */
                    me.element = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VisualEventDescriptor.element' } });
									/*
                    * C# parametr type: StringValue
                    */
                    me.targetUrl = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VisualEventDescriptor.targetUrl' } });
									/*
                    * C# parametr type: String
                    */
                    me.trigger = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VisualEventDescriptor.trigger' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function VisualEventsCollectionDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: VisualEventDescriptor (class/struct)
                    */
                    me.events = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VisualEventsCollectionDescriptor.events' } });
                    
										mappingOptions.events = { create: function(options) { return new VisualEventDescriptor(options.data, me, parents); } };
                    				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function VisualEventsGroupDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: List`1
                    *  - Generic parametr of type: VisualEventDescriptor (class/struct)
                    */
                    me.visualEvents = ko.observableArray().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VisualEventsGroupDescriptor.visualEvents' } });
                    
										mappingOptions.visualEvents = { create: function(options) { return new VisualEventDescriptor(options.data, me, parents); } };
                    				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function IconSizingValue(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.spacing = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'IconSizingValue.spacing' } });
									/*
                    * C# parametr type: String
                    */
                    me.size = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'IconSizingValue.size' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function IntegrationTypeValue(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.type = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'IntegrationTypeValue.type' } });
									/*
                    * C# parametr type: String
                    */
                    me.config = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'IntegrationTypeValue.config' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function PaddingValue(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.top = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PaddingValue.top' } });
									/*
                    * C# parametr type: String
                    */
                    me.right = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PaddingValue.right' } });
									/*
                    * C# parametr type: String
                    */
                    me.bottom = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PaddingValue.bottom' } });
									/*
                    * C# parametr type: String
                    */
                    me.left = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PaddingValue.left' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function PositionValue(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Boolean
                    */
                    me.boundingIsTextContent = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PositionValue.boundingIsTextContent' } });
									/*
                    * C# parametr type: String
                    */
                    me.zIndex = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PositionValue.zIndex' } });
									/*
                    * C# parametr type: String
                    */
                    me.xOffset = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PositionValue.xOffset' } });
									/*
                    * C# parametr type: String
                    */
                    me.yOffset = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PositionValue.yOffset' } });
									/*
                    * C# parametr type: String
                    */
                    me.position = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PositionValue.position' } });
									/*
                    * C# parametr type: String
                    */
                    me.prefPos = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PositionValue.prefPos' } });
									/*
                    * C# parametr type: String
                    */
                    me.width = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PositionValue.width' } });
									/*
                    * C# parametr type: String
                    */
                    me.minHeight = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PositionValue.minHeight' } });
									/*
                    * C# parametr type: String
                    */
                    me.maxHeight = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PositionValue.maxHeight' } });
									/*
                    * C# parametr type: String
                    */
                    me.scrollMargin = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PositionValue.scrollMargin' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.arrowToTarget = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'PositionValue.arrowToTarget' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function SizingValue(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.width = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SizingValue.width' } });
									/*
                    * C# parametr type: String
                    */
                    me.alignment = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'SizingValue.alignment' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function StringValue(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.equals = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'StringValue.equals' } });
									/*
                    * C# parametr type: String
                    */
                    me.contains = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'StringValue.contains' } });
									/*
                    * C# parametr type: String
                    */
                    me.startsWith = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'StringValue.startsWith' } });
									/*
                    * C# parametr type: String
                    */
                    me.endsWith = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'StringValue.endsWith' } });
									/*
                    * C# parametr type: String
                    */
                    me.parametrized = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'StringValue.parametrized' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function OnClickedTriggerOptions(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.selector = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'OnClickedTriggerOptions.selector' } });
									/*
                    * C# parametr type: Boolean
                    */
                    me.oneTime = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'OnClickedTriggerOptions.oneTime' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ScheduledTriggerOptions(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Int32
                    */
                    me.eachDays = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ScheduledTriggerOptions.eachDays' } });
									/*
                    * C# parametr type: String
                    */
                    me.until = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ScheduledTriggerOptions.until' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.maxStateCounter = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ScheduledTriggerOptions.maxStateCounter' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ActionButton(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Dictionary`2
                    */
                    me.text = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ActionButton.text' } });
									/*
                    * C# parametr type: String
                    */
                    me.action = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ActionButton.action' } });
									/*
                    * C# parametr type: Object
                    */
                    me.data = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ActionButton.data' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ButtonContent(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Dictionary`2
                    */
                    me.text = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonContent.text' } });
									/*
                    * C# parametr type: String
                    */
                    me.action = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonContent.action' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.tourId = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonContent.tourId' } });
									/*
                    * C# parametr type: Object
                    */
                    me.opts = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ButtonContent.opts' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function HeroContent(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Dictionary`2
                    */
                    me.text = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'HeroContent.text' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function HtmlContent(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.content = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'HtmlContent.content' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function IconElement(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.src = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'IconElement.src' } });
									/*
                    * C# parametr type: String
                    */
                    me.width = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'IconElement.width' } });
									/*
                    * C# parametr type: String
                    */
                    me.height = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'IconElement.height' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function MoodContent(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.tag = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'MoodContent.tag' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.dedicatedSend = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'MoodContent.dedicatedSend' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.question = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'MoodContent.question' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.followUp = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'MoodContent.followUp' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ParagraphContent(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.row = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.row' } });
									/*
                    * C# parametr type: String
                    */
                    me.dataId = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.dataId' } });
									/*
                    * C# parametr type: String
                    */
                    me.bgColor = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.bgColor' } });
									/*
                    * C# parametr type: String
                    */
                    me.textColor = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.textColor' } });
									/*
                    * C# parametr type: PaddingValue
                    */
                    me.padding = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.padding' } });
									/*
                    * C# parametr type: SizingValue
                    */
                    me.sizing = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.sizing' } });
									/*
                    * C# parametr type: String
                    */
                    me.objAlignment = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.objAlignment' } });
									/*
                    * C# parametr type: YouTubeVideoLink
                    */
                    me.youTube = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.youTube' } });
									/*
                    * C# parametr type: VideoLink
                    */
                    me.video = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.video' } });
									/*
                    * C# parametr type: ButtonContent
                    */
                    me.button = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.button' } });
									/*
                    * C# parametr type: HeroContent
                    */
                    me.hero = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.hero' } });
									/*
                    * C# parametr type: MoodContent
                    */
                    me.mood = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.mood' } });
									/*
                    * C# parametr type: TypeformContent
                    */
                    me.typeform = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.typeform' } });
									/*
                    * C# parametr type: HtmlContent
                    */
                    me.html = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.html' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.text = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ParagraphContent.text' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function TypeformContent(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.url = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TypeformContent.url' } });
									/*
                    * C# parametr type: String
                    */
                    me.height = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TypeformContent.height' } });
									/*
                    * C# parametr type: Boolean
                    */
                    me.continueOnSubmit = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TypeformContent.continueOnSubmit' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function VideoLink(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.origUrl = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VideoLink.origUrl' } });
									/*
                    * C# parametr type: String
                    */
                    me.url = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VideoLink.url' } });
									/*
                    * C# parametr type: String
                    */
                    me.height = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VideoLink.height' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.loop = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VideoLink.loop' } });
									/*
                    * C# parametr type: Nullable`1
                    */
                    me.autoplay = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'VideoLink.autoplay' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function YouTubeVideoLink(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Dictionary`2
                    */
                    me.url = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'YouTubeVideoLink.url' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function TourCardTitleDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Boolean
                    */
                    me.visible = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourCardTitleDescriptor.visible' } });
									/*
                    * C# parametr type: IconElement
                    */
                    me.icon = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourCardTitleDescriptor.icon' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.text = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourCardTitleDescriptor.text' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function TourCardFooterDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.visible = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourCardFooterDescriptor.visible' } });
									/*
                    * C# parametr type: StepsCounterDescriptor
                    */
                    me.stepsCounter = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourCardFooterDescriptor.stepsCounter' } });
									/*
                    * C# parametr type: ButtonInputDescriptor
                    */
                    me.skipButton = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourCardFooterDescriptor.skipButton' } });
									/*
                    * C# parametr type: ButtonInputDescriptor
                    */
                    me.nextButton = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourCardFooterDescriptor.nextButton' } });
									/*
                    * C# parametr type: ButtonInputDescriptor
                    */
                    me.backButton = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourCardFooterDescriptor.backButton' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.text = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'TourCardFooterDescriptor.text' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ContextHelpCardTitleDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.visible = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpCardTitleDescriptor.visible' } });
									/*
                    * C# parametr type: Dictionary`2
                    */
                    me.text = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpCardTitleDescriptor.text' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function ContextHelpCardFooterDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: Nullable`1
                    */
                    me.visible = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpCardFooterDescriptor.visible' } });
									/*
                    * C# parametr type: ButtonInputDescriptor
                    */
                    me.closeButton = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpCardFooterDescriptor.closeButton' } });
									/*
                    * C# parametr type: ButtonInputDescriptor
                    */
                    me.dismissButton = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ContextHelpCardFooterDescriptor.dismissButton' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		export function StepsCounterDescriptor(initObj, parentVm, parents) {
			var me = this;

			if (!parents) parents = [];
			var parentsOld = parents;

			parents = [];
			for (var i = 0; i < parentsOld.length; i++)
			{
			parents.push(parentsOld[i]);
			}

			parents.unshift(parentVm);

			var mappingOptions = {};
			
			me.__trackingEnabled = ko.observable();

								/*
                    * C# parametr type: String
                    */
                    me.position = ko.observable().extend({ trackChange: { enabler: me.__trackingEnabled, name: 'StepsCounterDescriptor.position' } });
				
			if(me._ModelExtender) {
				me._ModelExtender(me, parentVm, parents, mappingOptions);
			}

			if (initObj) {
				ko.mapping.fromJS(initObj, mappingOptions, me);
			}

			me.toJS = function() {
				var toClean = [];
				if(me.cleanBeforeSerialize) {
					toClean = me.cleanBeforeSerialize();
				}

				var toCleanMap = {};
				for(var i in toClean) {
					var key = toClean[i];
					toCleanMap[key] = me[key];
					me[key] = null;
				}

				var result = ko.toJS(me);

				for(var i in toCleanMap) {
					me[i] = toCleanMap[i];
				}

				return result;
			};

			me.__trackingEnabled(true);
		}
		